<template>
  <div ref="portfolio" class="hpanel hgreen collapsed portfolio" style="margin: 0">
    <div class="panel-heading hbuilt">
      <div class="panel-tools" style="margin: 10px">
        <div class="btn-group" style="margin-right: 15px">
          <template v-if="portfolio.name !== 'Projects shared with me'">
            <button class="btn btn-xs btn-info " @click="modalProjectAction = 'create'"><i class="fa fa-plus"></i> New Project</button>
            <button class="btn btn-xs btn-info btn-outline" @click="modalAction = 'edit'"><i class="fas fa-pencil-alt"></i> Edit</button>
            <button class="btn btn-xs btn-danger btn-outline" @click="modalAction = 'delete'"><i class="fa fa-remove"></i></button>
          </template>
        </div>

        <a class="showhide" ref="portfolioShowhide"><i class="fa fa-chevron-up"></i></a>
      </div>
      <h4>{{portfolio.name}}</h4>
    </div>

    <div class="panel-body portfolio">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <p v-if="portfolio.description" style="margin-top: 15px">
            {{portfolio.description}}
          </p>
          <p v-else style="font-style: italic">
            Brief project description...
          </p>

        </div>
        <div class="col-md-4  project-info border-left">
          <div class="text-center">
            <div class="col-xs-12">
              <div class="project-label">NUMBER OF PROJECTS</div>
              <small>{{portfolio.projects.length}}</small>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="panel-footer portfolio">
      <div class="text-right">
        <span> {{portfolio.created_at | moment('LLL')}}</span>
      </div>
    </div>

    <div class="panel-projects portfolio" style="margin: 0 15px">
      <div v-if="portfolio.projects">

        <template v-for="(project, key) in portfolio.projects">
          <template v-if="key % 2 === 0">
            <div class="row"></div>
          </template>
          <project-item :key="project.id" class="col-md-6" :project="project" v-model="refreshProject"/>

        </template>
      </div>
      <div v-else class="col-xs-12 text-center">
        <div>No projects in this portfolio, Add in one</div>
        <div>
          <button> Add</button>
        </div>
      </div>
    </div>

    <template v-if="modalAction !== null">
      <action-modal-portfolio :portfolio="portfolio" v-model="modalAction" :refresh="refresh"/>
    </template>

    <template v-if="modalProjectAction !== null">
      <action-modal-project :project="null" :portfolio="portfolio" v-model="modalProjectAction" :refresh="refresh"/>
    </template>

  </div>

</template>
<style scoped>
  .hpanel.collapsed .panel-projects {
    display: none;
  }

  @media (max-width: 768px) {
    .projects .project-info {
      text-align: right;
    }
  }
</style>

<script>
import ActionModalPortfolio from './ActionModalPortfolio'
import {showHidePanelPortfolio} from '../../assets/scripts/utils'
import ActionModalProject from './ActionModalProject'
import ProjectItem from './ProjectItem'

export default {
  components: {
    ProjectItem,
    ActionModalProject,
    ActionModalPortfolio
  },
  props: ['portfolio'],
  name: 'PortfolioListRow',
  watch: {
    refresh: function (value) {
      this.$emit('input', value)
    },
    refreshProject: function (value) {
      this.$emit('input', value)
    }
  },
  data () {
    return {
      modalAction: null,
      modalProjectAction: null,
      refreshProject: null
    }
  },
  methods: {
    refresh: function (value) {
      this.$emit('input', value)
    }
  },
  updated () {
  },
  mounted () {
    showHidePanelPortfolio($(this.$refs.portfolioShowhide))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/PortfolioListRow.vue